import { render, staticRenderFns } from "./checkback.vue?vue&type=template&id=38bf60b1"
import script from "./checkback.vue?vue&type=script&lang=js"
export * from "./checkback.vue?vue&type=script&lang=js"
import style0 from "./checkback.vue?vue&type=style&index=0&id=38bf60b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports